export default __webpack_public_path__ + "static/media/SG-DarkBlue-0006.f17b4363.png";